module.exports = __webpack_public_path__ + "static/media/spritze.54486db0.svg";